import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private _spinnerLoader$ = new BehaviorSubject<boolean>(false);
  private _loaderMessage$ = new BehaviorSubject<string>(String());
  private _destroying$ = new Subject<void>();

  constructor() { }

  show(): void {
    this._spinnerLoader$.next(true);
  }
  hide(): void {
    this._spinnerLoader$.next(false);
  }

  setMessage(message: string): void {
    this._loaderMessage$.next(message);
  }

  get spinnerLoader(): Observable<boolean> {
    return this._spinnerLoader$.asObservable()
      .pipe(takeUntil(this._destroying$));
  }

  get loaderMessage(): Observable<string> {
    return this._loaderMessage$.asObservable()
      .pipe(takeUntil(this._destroying$));;
  }

  clear(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
